// extracted by mini-css-extract-plugin
export var element = "QuotesSection-module--element--aa49c";
export var elementWrapper = "QuotesSection-module--elementWrapper--b3250";
export var list = "QuotesSection-module--list--070b7";